import {
  COLORS,
  TOP_TOOLBOX,
  RIGTH_TOOLBOX,
  HEIGH_GRID,
  TOP_GRID_SIN_LEYENDA,
  TOP_GRID,
  BOTTOM_GRID,
  RIGTH_GRID,
  LEFT_GRID,
  TOP_LEGEND,
  DIVSIZE,
} from './constants/constants';

const RIGTH_BUTTON_DOWNLOAD = 27;
const TOP_BUTTON_DOWNLOAD = 30;
const TOO_MANY_DIGITS = 9999999;

/**
 * Introduce . cada 3 cifras del número pasado por parámetros: 1234->1.234
 * @param {integer} value Entero al que se le va a poner.
 * @returns String con el número transformado.
 */
export function addPointInteger(value) {
  // Obtiene el idioma del navegador
  let usrlang = navigator.language || navigator.userLanguage;
  usrlang =
    usrlang.length <= 2 ? `${usrlang}-${usrlang.toUpperCase()}` : usrlang;
  const factorDigits = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  };
  return usrlang === 'es-ES'
    ? value.toLocaleString('de-DE', factorDigits)
    : value.toLocaleString(usrlang, factorDigits);
}
export function calculateXAxisMonth(date) {
  return (1 - 17 / date) * 100;
}
export function calculateXAxisYear(date) {
  return (1 - 7 / date) * 100;
}
export function formatTooltip(params, roundValues = false) {
  const colorSpan = (color) =>
    `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:${color}"></span>`;
  let rez = `<p>${params[0].name}</p>`;
  params.forEach((item) => {
    const val = roundValues ? Math.round(item.data) : item.data;
    const xx = `<div>${colorSpan(item.color)} ${
      item.seriesName
    }: <strong style="float: right; margin-left:20px">${
      item.data ? addPointInteger(val) : '-'
    }</strong></div>`;
    rez += xx;
  });
  return rez;
}

export function yAxisFormat(data) {
  return addPointInteger(data);
}

export function filterDatesUpdate() {
  const $inputsDate = $('#formFilterDates').find('input');
  const paramDate = [];
  $($inputsDate).each((index, element) => {
    if (element.checked) paramDate.push(element.id);
  });
  Dashboards.fireChange('filterDatesParam', paramDate);
  Dashboards.fireChange('updateFilter', 'True');
}

function initFilter() {
  let counter = 0;
  const $inputsDate = $('#formFilterDates').find('input');
  $($inputsDate).each((index, element) => {
    counter += 1;
    element.checked = true;
  });

  counter = 0;
  const $inputsVar = $('#formFilterVar').find('input');
  $($inputsVar).each((index, element) => {
    counter += 1;
    if (render_tableVariacio != null) {
      if (counter <= 2) element.checked = true;
    } else if (counter <= 3) element.checked = true;
  });

  if (Dashboards.getParameterValue('filterVarParam').length > 0) {
    Dashboards.fireChange('filterVarParam');
  }
}

function clearInputs() {
  const inputsDate = $('#formFilterDates').find('input');
  $(inputsDate).each((index, element) => {
    if (element.checked) element.checked = false;
  });

  const $inputsVar = $('#formFilterVar').find('input');
  $($inputsVar).each((index, element) => {
    if (element.checked) element.checked = false;
  });
  initFilter();
}
/**
 * Dado un valor entero, devuelve el mes/meses asociados a el: 01->Gen
 * @param {object/integer} data Valor a convertir en cadena
 * @returns Cadena asociada al valor.
 */
export function getMonth(data) {
  const monthDict = {
    1: 'Gen',
    2: 'Feb',
    3: 'Mar',
    4: 'Abr',
    5: 'Mai',
    6: 'Jun',
    7: 'Jul',
    8: 'Ago',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Des',
  };
  return monthDict[parseInt(data.toString(), 10)];
}

export function getMonthComplete(data) {
  const monthDict = {
    1: 'GENER',
    2: 'FEBRER',
    3: 'MARÇ',
    4: 'ABRIL',
    5: 'MAIG',
    6: 'JUNY',
    7: 'JULIO',
    8: 'AGOST',
    9: 'SETEMBRE',
    10: 'OCTUBRE',
    11: 'NOVEMBRE',
    12: 'DESEMBRE',
  };
  return monthDict[data];
}
export function printNoDataChart(idHide, idShow) {
  const bg = "url('./build/images/nodata1.png') no-repeat top center";
  const hideElement = idHide ? document.querySelector(idHide) : null;
  const showElement = idShow ? document.querySelector(idShow) : null;

  if (hideElement) {
    hideElement.hidden = true;
  }
  if (showElement) {
    showElement.style.background = bg;
    showElement.hidden = false;
  }
}

export function printDataChart(idHide, idShow) {
  const hideElement = idHide ? document.querySelector(idHide) : null;
  const showElement = idShow ? document.querySelector(idShow) : null;

  if (hideElement) {
    hideElement.hidden = true;
  }
  if (showElement) {
    showElement.style.background = '#ffffff';
    showElement.hidden = false;
  }
}
/**
 * Separa el conjunto de datos "data" en función de la columna "column"
 * @param {array} data Conjunto de datos a separar y agrupar
 * @param {integer} column Columna por la que se va a agrupar
 * @returns Diccionario con el array "data" agrupado por "column"
 */
export function splitData(data, column) {
  return data.reduce((accumulator, currentValue) => {
    const key = currentValue[column];
    if (!accumulator[key]) {
      accumulator[key] = [];
    }
    accumulator[key].push(currentValue);
    return accumulator;
  }, {});
}
/**
 * Método que devuelve el máximo de una columna en concreto de un array.
 * @param {array} array Array que contiene la columna a tratar.
 * @param {integer} column Indice de la columna.
 * @param {float} add Si se quiere incrementar el máximo en X unidades.
 * @returns el valor máximo de array en la columna column
 */
export function getMaxValue(array, column, add = 1) {
  const max = Math.max(...array.map((row) => row[column])) * add;
  return Math.ceil(max / 5000) * 5000;
}

/**
 * Método que devuelve el ancho de la gráfica.
 * @param {string} column contine el nombre del identificador HTML del char.
 * @returns el ancho de la gráfica
 */
export function getWidthElementChart(idChart) {
  return Math.round(document.getElementById(idChart).offsetWidth / DIVSIZE);
}

export function getCommonOptions(
  series,
  legendData,
  xAxisData,
  yAxisName,
  xAxisStart,
  xFilter,
  nameMarginY,
  marginAxis = 5,
  chartName = '',
  datazoomStart = xAxisStart,
  datazoomEnd = 100,
  objTiposSelected,
  legendSpace = undefined,
  minData = undefined,
) {
  const legendProperties = {
    type: 'plain',
    data: legendData,
    textStyle: {
      fontFamily: 'Montserrat',
    },
    top: legendSpace || TOP_LEGEND,
    selected: objTiposSelected,
  };
  // Para quitar la leyenda hay que pasar el parámetro legendData con valor null.

  const legend = legendData ? legendProperties : null;
  // Valores por defecto de cualquier grid con leyenda
  const grid = {
    left: LEFT_GRID,
    right: RIGTH_GRID,
    bottom: BOTTOM_GRID,
    top: legendData ? (legendSpace ? '30%' : TOP_GRID) : TOP_GRID_SIN_LEYENDA,
    heigh: HEIGH_GRID,
    containLabel: true,
  };

  return {
    title: {
      text: chartName,
      left: 'center',
      top: 'top',
      textStyle: {
        fontSize: 20,
        fontFamily: 'Montserrat',
        fontWeight: 600,
        color: '#666',
      },
    },
    tooltip: {
      trigger: 'axis',
      show: true,
      formatter: (params) => formatTooltip(params),
      textStyle: {
        fontFamily: 'Montserrat',
      },
    },
    legend,

    grid,
    xAxis: {
      type: 'category',
      data: xAxisData,
      boundaryGap: false,
      splitLine: {
        show: false,
      },
      axisLabel: {
        textStyle: {
          fontSize: 10,
          fontFamily: 'Montserrat',
          color: '#666',
        },
      },
    },
    yAxis: {
      name: yAxisName,
      nameLocation: 'end',
      nameTextStyle: {
        fontFamily: 'Montserrat',
        fontWeight: 'bold',
        padding: [0, 0, 0, nameMarginY],
      },
      type: 'value',
      scale: true,
      min: minData,
      axisLabel: {
        margin: marginAxis,
        formatter: yAxisFormat,
        textStyle: {
          fontSize: 10,
          fontFamily: 'Montserrat',
          color: '#666',
        },
      },
    },
    series,
    dataZoom: [
      {
        show: xFilter,
        data: xAxisData,
        start: datazoomStart,
        end: datazoomEnd,
        borderColor: '#eee',
        fillerColor: 'rgba(0,0,0,.05)',
        textStyle: {
          fontSize: 10,
          fontFamily: 'Montserrat',
          color: '#333',
          textBorderColor: '#fff',
          textBorderWidth: 3,
          fontWeight: '600',
        },
        selectedDataBackground: {
          lineStyle: {
            color: '#333',
          },
          areaStyle: {
            color: '#ffcd00',
          },
        },
        dataBackground: {
          backgroundColor: 'rgba(0,0,0,1)',
          lineStyle: {
            color: '#333',
          },
          areaStyle: {
            color: 'rgba(0,0,0,0.5)',
          },
        },
        handleStyle: {
          color: 'rgba(0,0,0,0.2)',
        },
        moveHandleStyle: {
          color: 'rgba(0,0,0,0.3)',
        },
        emphasis: {
          handleStyle: {
            color: 'rgba(255,205,0,1)',
          },
          moveHandleStyle: {
            color: 'rgba(255,205,0,1)',
          },
        },
      },
    ],
    toolbox: {
      show: xFilter,
      feature: {
        restore: { title: 'Restablir' },
        saveAsImage: { title: 'Desar' },
      },
      right: RIGTH_TOOLBOX,
      top: TOP_TOOLBOX,
    },
  };
}
/**
 * Configura e inicializa el grafico de barras apiladas verticalmente
 * a partir de un conjunto inicial de datos
 * @param {string} idChart id del div del grafico
 * @param {string} idNoData id del div de no hay datos
 * @param {array} misDatosArray Conjunto inicial de datos
 * @param {string} nombreLabel Nombre de la label
 * @param {string} chartName Nombre del gráfico
 * @param {array} colors Colores de las labels
 * @param {array} borders Color del borde de las labels
 * @returns none
 */
export function echartVerStackedBar(
  idChart,
  idNoData,
  misDatosArray,
  nombreLabel,
  chartName = '',
  apilar = 'total',
  COL_SPLIT = 0,
  COL_FECHA = 1,
  COL_DATO = 2,
  colors = COLORS,
) {
  if (misDatosArray.length === 0) {
    printNoDataChart(`#${idChart}`, `#${idNoData}`);
  } else {
    printDataChart(`#${idNoData}`, `#${idChart}`);
    const dataset = [];
    let separatedData = splitData(misDatosArray, COL_SPLIT);
    const fechas = new Set(
      misDatosArray.map((subArray) => subArray[COL_FECHA]),
    );
    const categories = Object.keys(separatedData);
    fechas.forEach((fecha) => {
      categories.forEach((category) => {
        const isDate = separatedData[category].find(
          (subArray) => subArray[COL_FECHA] === fecha,
        );
        if (isDate === undefined) {
          separatedData[category].push([
            separatedData[category][0][COL_SPLIT],
            fecha,
            undefined,
          ]);
          if (separatedData[category][0][1].length > 4) {
            separatedData[category].sort((dateStr1, dateStr2) => {
              const [month1, year1] = dateStr1[1].split('/');
              const [month2, year2] = dateStr2[1].split('/');
              const date1 = new Date(year1, month1 - 1, 1);
              const date2 = new Date(year2, month2 - 1, 1);
              return date1.getTime() - date2.getTime();
            });
          } else {
            separatedData[category].sort();
          }
        }
      });
    });
    const orderedData = Object.entries(separatedData).sort((a, b) =>
      a[0].localeCompare(b[0]),
    );
    const rotacion = apilar === '' ? 90 : 0;
    separatedData = Object.fromEntries(orderedData);
    Object.keys(separatedData).forEach((category) => {
      dataset.push({
        name: category,
        type: 'bar',
        stack: apilar,
        label: {
          show: true,
          fontFamily: 'Montserrat',
          rotate: rotacion,
          formatter: (params) => addPointInteger(Math.round(params.value)),
        },
        emphasis: {
          focus: 'series',
        },
        data: separatedData[category].map((subArray) => subArray[COL_DATO]),
      });
    });
    const xAxisStart =
      apilar !== ''
        ? calculateXAxisMonth(fechas.size)
        : calculateXAxisYear(fechas.size);
    const options = {
      color: colors,
      title: {
        text: chartName,
        left: 'center',
        top: 'top',
        textStyle: {
          fontSize: 20,
          fontFamily: 'Montserrat',
          fontWeight: 600,
          color: '#666',
        },
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        textStyle: {
          fontFamily: 'Montserrat',
        },
        formatter: (params) => formatTooltip(params, true),
      },
      legend: {
        padding: 40,
        textStyle: {
          fontFamily: 'Montserrat',
        },
      },
      grid: {
        left: LEFT_GRID,
        right: RIGTH_GRID,
        bottom: BOTTOM_GRID,
        top: TOP_GRID,
        heigh: HEIGH_GRID,
        containLabel: true,
      },
      yAxis: {
        type: 'value',
        splitNumber: 4,
        name: nombreLabel,
        nameLocation: 'end',
        nameTextStyle: {
          fontWeight: 'bold',
          fontFamily: 'Montserrat',
          color: '#666',
        },
        axisLabel: {
          formatter: yAxisFormat,
          textStyle: {
            fontSize: 8,
            fontFamily: 'Montserrat',
            color: '#666',
          },
        },
      },
      xAxis: {
        type: 'category',
        data: [...fechas],
        axisLabel: {
          textStyle: {
            fontFamily: 'Montserrat',
          },
        },
      },
      series: dataset,
      toolbox: {
        show: true,
        feature: {
          restore: { title: 'Restablir' },
          saveAsImage: { title: 'Desar' },
        },
        right: 50,
      },
      dataZoom: [
        {
          show: true,
          data: [...fechas],
          start: xAxisStart,
          end: 100,
          borderColor: '#eee',
          fillerColor: 'rgba(0,0,0,.05)',
          textStyle: {
            fontSize: 10,
            fontFamily: 'Montserrat',
            color: '#333',
            textBorderColor: '#fff',
            textBorderWidth: 3,
            fontWeight: '600',
          },
          selectedDataBackground: {
            lineStyle: {
              color: '#333',
            },
            areaStyle: {
              color: '#ffcd00',
            },
          },
          dataBackground: {
            backgroundColor: 'rgba(0,0,0,1)',
            lineStyle: {
              color: '#333',
            },
            areaStyle: {
              color: 'rgba(0,0,0,0.5)',
            },
          },
          handleStyle: {
            color: 'rgba(0,0,0,0.2)',
          },
          moveHandleStyle: {
            color: 'rgba(0,0,0,0.3)',
          },
          emphasis: {
            handleStyle: {
              color: 'rgba(255,205,0,1)',
            },
            moveHandleStyle: {
              color: 'rgba(255,205,0,1)',
            },
          },
        },
      ],
    };
    initChart(idChart, options);
  }
}

/**
 * Inicializa el grafico de mes de datos desagregados.
 * @param {string} idChart Nombre del chart del mes actual
 * @param {string} idChartAnterior Nombre del chart del mes anterior
 * @param {string} idNoData Nombre del chart sin datos del mes actual
 * @param {string} idNoDataAnterior Nombre del chart sin datos del mes actual
 * @param {array} misDatosArray Conjunto inicial de datos
 * @param {string} nombreLabelActual Nombre del grafico del mes actual
 * @param {string} nombreLabelAnterior Nombre del grafico del mes anterior
 */
export function echartGaugeMonth(
  idChart,
  idChartAnterior,
  idNoData,
  idNoDataAnterior,
  misDatosArray,
  nombreLabelActual,
  nombreLabelAnterior,
) {
  if (misDatosArray.length === 0) {
    printNoDataChart(`#${idChart}`, `#${idNoData}`);
    printNoDataChart(`#${idChartAnterior}`, `#${idNoDataAnterior}`);
  } else {
    printDataChart(`#${idNoData}`, `#${idChart}`);
    printDataChart(`#${idNoDataAnterior}`, `#${idChartAnterior}`);
    const COL_TIPO = 0;
    const COL_MES = 1;
    const COL_DATO = 2;
    const configuredData = configureDataGaugeMonth(
      misDatosArray,
      COL_DATO,
      COL_MES,
    );
    const gaugeData = configuredData[0];
    const gaugeDataLM = configuredData[1];
    const separatedData = configuredData[2];
    const maxValue = configuredData[3];
    const calculatedOffset = configuredData[5];

    // Se obtienen el ancho para las gráficas
    const newFontSize = getWidthElementChart(idChart);

    const gaugeDataMonth = createGauge(
      gaugeData,
      COL_DATO,
      COL_TIPO,
      calculatedOffset,
      newFontSize,
    );
    const gaugeDataLastMonth = createGauge(
      gaugeDataLM,
      COL_DATO,
      COL_TIPO,
      calculatedOffset,
      newFontSize,
    );

    const nombreMesActual = `${nombreLabelActual}${getMonthComplete(
      String(Object.keys(separatedData)[1]),
    )}`;

    const options = getConfigurationGaugeYears(
      nombreMesActual,
      maxValue,
      gaugeDataMonth,
      newFontSize,
      false,
    );
    initChart(idChart, options);

    const optionslastMonth = getConfigurationGaugeYears(
      `${nombreLabelAnterior}${getMonthComplete(
        String(Object.keys(separatedData)[0]),
      )}`,
      maxValue,
      gaugeDataLastMonth,
      newFontSize,
      false,
    );
    initChart(idChartAnterior, optionslastMonth);
  }
}
/**
 * Inicializa el grafico de mes de datos desagregados.
 * @param {string} idChart Nombre del chart del año actual
 * @param {string} idNoData Nombre del chart sin datos del año actual
 * @param {array} misDatosArray Conjunto inicial de datos
 * @param {string} nombreLabelActual Nombre del grafico del año actual
 */
export function echartGaugeYear(idChart, idNoData, misDatosArray, nombreLabel) {
  if (misDatosArray.length === 0) {
    printNoDataChart(`#${idChart}`, `#${idNoData}`);
  } else {
    printDataChart(`#${idNoData}`, `#${idChart}`);
  }
  const COL_TIPO = 0;
  const COL_DATO = 1;
  const COL_ANYO = 2;
  const maxValue = getMaxValue(misDatosArray, COL_DATO, 1.1);

  // Se obtienen el ancho para las gráficas
  const newFontSize = getWidthElementChart(idChart);

  let calculatedOffset = 180;
  if (maxValue > TOO_MANY_DIGITS) {
    calculatedOffset = 95;
  }
  const gaugeDataYears = createGauge(
    misDatosArray,
    COL_DATO,
    COL_TIPO,
    calculatedOffset,
    newFontSize,
  );
  const options = getConfigurationGaugeYears(
    `${nombreLabel} ${misDatosArray[0][COL_ANYO]}`,
    maxValue,
    gaugeDataYears,
    newFontSize,
    false,
  );
  initChart(idChart, options);
}
/**
 * Configura el grafico de barras a partir de un conjunto
 * inicial de datos
 * @param {array} misDatosArray Conjunto inicial de datos
 * @returns Configuración del chart completa
 */
export function getCommonOptionsBar(
  misDatosArray,
  nombreLabel,
  NAME_MARGIN_Y = -45,
  chartName = '',
  nameYAxis = nombreLabel,
) {
  const date = new Set();
  const dataset = [];
  misDatosArray.forEach((i) => {
    const day = i[0].toString().padStart(2, '0');
    date.add(`${day}/${i[1]}`);
    dataset.push(Math.round(i[2]));
  });

  const xAxisStart = dataset.length < 100 ? 40 : 80;

  const series = {
    name: nameYAxis,
    type: 'bar',
    smooth: false,
    barMaxWidth: 40,
    itemStyle: {
      color: '#5470c6',
    },
    textStyle: {
      fontFamily: 'Montserrat',
    },
    data: dataset,
  };
  return getCommonOptions(
    series,
    null,
    Array.from(date.values()),
    nombreLabel,
    xAxisStart,
    true,
    NAME_MARGIN_Y,
    25,
    chartName,
  );
}
/**
 * Formateo del tooltip de gauge y pie
 * @param {object} params elementos del parámetro a formatear
 * @param {boolean} isPie Determina si es pie o no para mostrar %
 * @returns cadena formateada.
 */
export function formatRoundTooltip(params, isPie) {
  const icon = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color};"></span>`;
  let label = `${params.name} : `;
  label += `<span style="font-weight:bold">${addPointInteger(
    params.value,
  )}</span>`;
  if (isPie) {
    label += `<span> (${params.percent}%)</span>`;
  }
  return icon + label;
}
export function getCommonOptionGaugeUmbral(
  data,
  porcentajeUmbralRojo,
  porcentajeUmbralAmarillo,
  textData,
) {
  return {
    series: [
      {
        type: 'gauge',
        center: ['50%', '50%'],
        startAngle: 200,
        endAngle: -20,
        min: 0,
        max: 100,
        splitNumber: 0,
        progress: {
          show: false,
          width: 5,
          itemStyle: {
            color: '#666',
          },
        },
        axisLine: {
          lineStyle: {
            width: 18,
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          length: 15,
          lineStyle: {
            width: 2,
            color: '#999',
          },
        },
        axisLabel: {
          distance: 25,
          color: '#999',
          fontSize: 20,
          show: false,
        },
        anchor: {
          show: true,
          showAbove: true,
          size: 25,
          itemStyle: {
            borderWidth: 10,
          },
          show: false,
        },
        pointer: {
          show: true,
          icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
          length: '12%',
          width: 20,
          offsetCenter: [0, '-40%'],
          itemStyle: {
            color: '#ccc',
          },
        },
        axisLine: {
          lineStyle: {
            width: 35,
            color: [
              [porcentajeUmbralRojo, '#e56b6f'],
              [porcentajeUmbralRojo + porcentajeUmbralAmarillo, '#ffbf69'],
              [1, '#a1c483'],
            ],
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        title: {
          show: true,
          offsetCenter: [0, '45%'],
          textStyle: {
            color: '#000',
            fontStyle: 'normal',
            fontWeight: '400',
            fontFamily: 'Montserrat',
            fontSize: 15,
          },
        },
        detail: {
          fontSize: 30,
          offsetCenter: [0, '90%'],
          valueAnimation: true,
          color: '#666',
          textStyle: {
            color: '#000',
            fontStyle: 'normal',
            fontWeight: '400',
            fontFamily: 'Montserrat',
            fontSize: 35,
          },
        },
        data: [
          {
            value: data,
            name: textData,
          },
        ],
      },
    ],
  };
}
/**
 * Configura el grafico donut a partir de un conjunto inicial de datos
 * @param {Array} data Array de objetos {value:, name: } con los datos del grafico
 * @param {string} titleText
 * @param {Array} radius
 * @param {Array} colors
 * @returns  Configuracion opciones del echart
 */

export function getCommonOptionDonut(data, titleText, radius, colors) {
  return {
    tooltip: {
      trigger: 'item',
      formatter: (params) => formatRoundTooltip(params, false),
      textStyle: {
        fontSize: 13.5,
        fontFamily: 'Montserrat',
        fontWeight: 400,
        color: '#333',
      },
    },
    title: {
      text: titleText,
      left: 'center',
      top: '40%',
      textStyle: {
        fontSize: 13.5,
        fontFamily: 'Montserrat',
        fontWeight: 400,
        color: '#333',
      },
    },
    legend: {
      left: 'center',
      bottom: '0%',
      textStyle: {
        fontSize: 10,
        fontFamily: 'Montserrat',
        fontWeight: 400,
        color: '#333',
      },
    },
    series: [
      {
        top: '0%',
        bottom: '15%',
        type: 'pie',
        radius: radius || ['65%', '75%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 5,
          borderColor: '#f1f1f1',
          borderWidth: 1,
        },
        label: {
          show: false,
          position: 'center',
          textStyle: {
            fontSize: 20,
            fontFamily: 'Montserrat',
            fontWeight: 400,
            color: '#333',
          },
        },
        emphasis: {
          label: {
            show: false,
            fontSize: 20,
          },
        },
        labelLine: {
          show: false,
        },
        color: colors || [
          '#fcb9b2',
          '#ffd97d',
          '#64a6bd',
          '#98c9a3',
          '#ff9b85',
        ],
        data,
      },
    ],
  };
}
/**
 * Configura el pie a partir de un conjunto inicial de datos
 * @param {string} chartName Nombre del gráfico
 * @param {Array} dataPie Datos del grafico
 * @returns Configuracion del chart completa
 */
export function getCommonOptionPie(
  chartName,
  dataPie,
  newFontSize,
  colors = COLORS,
) {
  const marginLeftLegend = dataPie.length > 5 ? '10%' : '12%';
  return {
    textStyle: {
      fontFamily: 'Montserrat',
    },
    title: {
      text: chartName,
      left: 'center',
      top: 'top',
      padding: 10,
      textStyle: {
        fontSize: newFontSize - 4,
        fontFamily: 'Montserrat',
        fontWeight: 600,
        color: '#666',
      },
    },
    tooltip: {
      trigger: 'item',
      textStyle: {
        fontFamily: 'Montserrat',
      },
      formatter: (params) => formatRoundTooltip(params, true),
    },
    legend: {
      orient: 'horizontal',
      textStyle: {
        fontFamily: 'Montserrat',
      },
      left: marginLeftLegend,
      bottom: '10%',
      top: '65%',
      selectedMode: false,
    },
    series: [
      {
        type: 'pie',
        radius: '33%',
        data: dataPie,
        color: colors,
        top: '-30%',
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
    toolbox: {
      show: true,
      feature: {
        saveAsImage: { title: 'Desar' },
      },
      right: 10,
      top: 20,
    },
  };
}
export function getConfigurationGaugeYears(
  chartName,
  maxValue,
  gaugeData,
  newFontSize,
) {
  return {
    color: COLORS,
    title: {
      text: chartName,
      left: 'center',
      top: 'top',
      padding: 10,
      textStyle: {
        fontSize: newFontSize,
        fontFamily: 'Montserrat',
        fontWeight: 600,
        color: '#666',
      },
    },
    tooltip: {
      show: true,
      textStyle: {
        fontFamily: 'Montserrat',
      },
      formatter: (params) => formatRoundTooltip(params, false),
    },
    splitNumber: 3,
    series: {
      type: 'gauge',
      max: maxValue,
      startAngle: -180,
      endAngle: 0,
      splitNumber: 2,
      pointer: {
        show: false,
        icon: 'roundRect',
      },
      progress: {
        show: true,
        overlap: false,
        roundCap: true,
        clip: true,
        itemStyle: {
          borderWidth: 1,
          borderColor: '#464646',
        },
      },
      axisLine: {
        lineStyle: {
          width: 60,
        },
      },
      splitLine: {
        show: true,
        distance: 10,
        length: 10,
      },
      axisTick: {
        show: true,
        splitNumber: 5,
      },
      axisLabel: {
        show: true,
        distance: 70,
        formatter: (value) => addPointInteger(Math.round(value)),
        fontFamily: 'Montserrat',
        color: '#666',
      },
      data: gaugeData,
      detail: {
        fontSize: newFontSize / 1.2,
        color: 'inherit',
        formatter: (value) => addPointInteger(Math.round(value)),
      },
    },
    toolbox: {
      show: true,
      feature: {
        saveAsImage: { title: 'Desar' },
      },
      right: RIGTH_BUTTON_DOWNLOAD,
      top: TOP_BUTTON_DOWNLOAD,
    },
  };
}

/**
 * Separa las cadenas con una longitud >=30 para su correcta representación en los gauges.
 * @param {String} name Nombre a formatear.
 * @returns Cadena formateada.
 */
export function formatName(name) {
  if (name.length >= 29) {
    const words = name.split(' ');
    let currentLine = '';
    let result = '';
    for (const word of words) {
      if (`${currentLine} ${word}`.length <= 29) {
        currentLine += (currentLine ? ' ' : '') + word;
      } else {
        result += `${currentLine}\n`;
        currentLine = word;
      }
    }
    result += currentLine;
    return result;
  }
  return name;
}
/**
 * Crea la configuracíon de los datos de un gauge.
 * @param {array} gaugeData datos iniciales
 * @param {int} COL_DATO columna del dato en los datos iniciales
 * @param {int} COL_TIPO columna del tipo en los datos iniciales
 * @param {float} calculatedOffset offset inicial
 * @param {int} newFontSize tamaño de letra
 * @returns Datos configurados.
 */
export function createGauge(
  gaugeData,
  COL_DATO,
  COL_TIPO,
  calculatedOffset,
  newFontSize,
) {
  let offsetCenterTitle = 20;
  let offsetCenterDetail = 35;
  let offsetLabel = -190;
  let calOffset = calculatedOffset;
  if (gaugeData.length <= 2) {
    offsetLabel = -140;
    calOffset += 100;
    offsetCenterTitle = 25;
    offsetCenterDetail = 42;
  }
  const colorsCopy = COLORS.slice();
  const gaugeDataMonth = [];
  for (let i = 0; i < gaugeData.length; i += 1) {
    gaugeDataMonth.push({
      value: gaugeData[i][COL_DATO],
      name: formatName(gaugeData[i][COL_TIPO]),
      color: colorsCopy.shift(),
      title: {
        offsetCenter: [String(offsetLabel), `${String(offsetCenterTitle)}%`],
        fontFamily: 'Montserrat',
        fontSize: newFontSize - 3,
      },
      detail: {
        offsetCenter: [String(offsetLabel), `${String(offsetCenterDetail)}%`],
        fontFamily: 'Montserrat',
      },
    });
    offsetLabel += calOffset;
    if ((i + 1) % 3 === 0) {
      offsetCenterDetail += 30;
      offsetCenterTitle += 30;
      offsetLabel = -190;
    }
  }
  return gaugeDataMonth;
}
/**
 * Configura los datos para los gráficos de líneas.
 * @param {array} datos datos iniciales.
 * @returns Datos configurados.
 */
export function configureDataLine(datos, color, isDecimal = false) {
  const { resultset } = { resultset: datos };
  const tipos = new Set();
  const date = new Set();
  const colors = color;
  const dataObj = resultset.map(([tipo, fecha, dato]) => {
    const val = isDecimal ? Math.round(dato) : dato;
    tipos.add(tipo);
    date.add(fecha);
    return { day: fecha, type: tipo, value: val };
  });
  const datesArray = Array.from(date.values());
  const tiposArray = Array.from(tipos.values());
  // Ordenar si los nombres vienen desordenados:
  tiposArray.sort((a, b) =>
    a
      .toLowerCase()
      .localeCompare(b.toLowerCase(), 'es', { ignorePunctuation: true }),
  );

  const series = tiposArray.map((tipo) => {
    const arrayData = dataObj
      .filter((obj) => obj.type === tipo)
      .map(({ day, value }) => [day, tipo, value]);

    const arrayDataClean = datesArray.map((fecha) => {
      const obj = arrayData.find(([d]) => d === fecha);
      return obj ? obj[2] : null;
    });
    return {
      name: tipo,
      type: 'line',
      symbol: 'circle',
      color: colors.shift(),
      symbolSize: 6,
      smooth: false,
      data: arrayDataClean,
    };
  });
  return [series, date, tiposArray];
}

export function configureDataGaugeMonth(misDatosArray, COL_DATO, COL_MES) {
  const maxValue = getMaxValue(misDatosArray, COL_DATO, 1.1);
  let calculatedWidth = 50;
  let calculatedOffset = 180;
  if (maxValue > TOO_MANY_DIGITS) {
    calculatedWidth = 65;
    calculatedOffset = 95;
  }
  const separatedData = splitData(misDatosArray, COL_MES);

  let [gaugeDataLastMonth, gaugeData] = Object.values(separatedData);
  Object.values(separatedData)
    .slice(1)
    .forEach((month) => {
      gaugeData = month;
    });
  return [
    gaugeData,
    gaugeDataLastMonth,
    separatedData,
    maxValue,
    calculatedWidth,
    calculatedOffset,
  ];
}
export function initChart(chartId, option) {
  const chartElem = document.getElementById(chartId);
  if (!chartElem) {
    console.error(`No se pudo encontrar el elemento con ID ${chartId}.`);
    return null;
  }
  const myChart = echarts.init(chartElem);
  myChart.setOption(option, true);

  $(window).on('resize', () => {
    if (myChart != null && myChart !== undefined) {
      myChart.resize();
    }
  });
  return myChart;
}

export function commonPostFetch() {
  $('#chart2').css('width', '100%');
}

export function includeHTMLMenu(id) {
  // Id marca el botón al que hay que asignar marco (panel en el que nos encontramos)
  let i;
  let elmnt;
  let file;
  let xhttp;
  /* loop through a collection of all HTML elements: */
  const z = document.getElementsByTagName('*');
  for (i = 0; i < z.length; i += 1) {
    elmnt = z[i];
    file = elmnt.getAttribute('include-html-menu');
    if (file) {
      xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        // Cuando cambia de estado
        if (this.readyState === 4) {
          // Si la operación está terminada
          if (this.status === 200) {
            elmnt.innerHTML = this.responseText;
            $(id).removeClass('imgNavMenu');
            $(id).addClass('imgNavMenuActive');
          } // Si no hay errores, inyecto
          if (this.status === 404) {
            elmnt.innerHTML = 'No se ha podido cargar correctamente.';
          }
        }
      };
      xhttp.open('GET', file, true);
      xhttp.send();
      return;
    }
  }
}

export function includeHTMLCabecera() {
  let i;
  let elmnt;
  let file;
  let xhttp;
  /* loop through a collection of all HTML elements: */
  const z = document.getElementsByTagName('*');
  for (i = 0; i < z.length; i += 1) {
    elmnt = z[i];
    file = elmnt.getAttribute('include-html-cabecera');
    if (file) {
      xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        // Cuando cambia de estado
        if (this.readyState === 4) {
          // Si la operación está terminada
          if (this.status === 200) {
            elmnt.innerHTML = this.responseText;
          } // Si no hay errores, inyecto
          if (this.status === 404) {
            elmnt.innerHTML = 'No se ha podido cargar correctamente.';
          }
        }
      };
      xhttp.open('GET', file, true);
      xhttp.send();
      return;
    }
  }
}

export function includeHTMLFooter() {
  let i;
  let elmnt;
  let file;
  let xhttp;
  const z = document.getElementsByTagName('*');
  for (i = 0; i < z.length; i += 1) {
    elmnt = z[i];
    file = elmnt.getAttribute('include-html-footer');
    if (file) {
      xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        // Cuando cambia de estado
        if (this.readyState === 4) {
          // Si la operación está terminada
          if (this.status === 200) {
            elmnt.innerHTML = this.responseText;
          } // Si no hay errores, inyecto
          if (this.status === 404) {
            elmnt.innerHTML = 'No se ha podido cargar correctamente.';
          }
        }
      };
      xhttp.open('GET', file, true);
      xhttp.send();
      return;
    }
  }
}

export function closeFilter() {
  $('#layoutFilter').hide();
}

export function calcularRuta(ruta) {
  document.location = `${document.documentURI.split('%3A')[0]}%3A${
    document.documentURI.split('%3A')[1]
  }%3A${document.documentURI.split('%3A')[2]}%3A${
    document.documentURI.split('%3A')[3]
  }%3A${ruta}`;
}

export function obtenerRuta(ruta) {
  return `${document.documentURI.split('%3A')[0]}%3A${
    document.documentURI.split('%3A')[1]
  }%3A${document.documentURI.split('%3A')[2]}%3A${
    document.documentURI.split('%3A')[3]
  }%3A${ruta}`;
}

export function llamadasIniciales(id) {
  $(document).click(() => {
    const container = $('#layoutFilter');
    if (!container.is(event.target) && !container.has(event.target).length) {
      container.hide();
    }
  });
  includeHTMLCabecera(); // Inyecta el HTML perteneciente a la cabecera.
  includeHTMLMenu(id); // Inyecta el HTML perteneciente al menú de los diferentes paneles.
  includeHTMLFooter(); // Inyecta el HTML perteneciente al pie de página.
}

export function filterVarUpdate() {
  const $inputsDate = $('#idFilterVar').find('input');
  const paramDate = [];
  $($inputsDate).each((index, element) => {
    if (element.checked) paramDate.push(element.id.replaceAll('/', '-'));
  });
  Dashboards.fireChange('filterVarParam', paramDate);
  Dashboards.fireChange('updateFilterVar', 'True');
}

export function createCheckBoxFilterVar(sizeOfCheckBox, uniqueData) {
  const $container = $('#formFilterVar');

  if (Dashboards.getParameterValue('updateFilterVar') === '') {
    for (let i = uniqueData.length - 1; i >= 0; i--) {
      $container.append(
        `<input type="checkbox" id="${uniqueData[i]}" onclick="legacy.filterVarUpdate();" />${uniqueData[i]}<br /></input>`,
      );
    }
    clearInputs();
    filterVarUpdate();
  }
}

/**
 * TODO: Cambiar nombre
 * Formatea una fecha UTC a un formato dd/mm/YYYY
 * @param {Date} date
 * @returns un string con la fecha en formato dd/mm/YYYY
 */
export function formatearFecha(date) {
  let dia = date.getUTCDate().toString();
  if (dia.length === 1) {
    dia = `0${dia}`;
  }

  let mes = (date.getMonth() + 1).toString();
  if (mes.length === 1) {
    mes = `0${mes}`;
  }

  const anyo = date.getFullYear().toString();

  return `${dia}/${mes}/${anyo}`;
}

/**
 * TODO: Cambiar fecha
 * Formatea una fecha MM-DD en formato dd/mm
 * @param {Date} date
 * @returns un string con la fecha en formato dd/mm
 */
export function formatDDMM(date) {
  const month = date.slice(0, 2);
  const day = date.slice(3, 5);
  return `${day}/${month}`;
}

/**
 * Obtiene la hora en formato HH:MM a partir de un Date
 * @param {Date} date
 * @returns un string de la hora en formato HH:MM
 */
export function getTime(date) {
  const regex = /(\d{2}:\d{2})/;
  const matches = date.toString().match(regex);
  const hora = matches ? matches[1] : null;

  return hora;
}

/**
 * TODO: Calcular inicio del datazoom
 * Devuelve el valor en el que comenzará el datazoom de la gráfica
 * En todas las gráficas se mostrarán los últimos 4 meses, excepto en temperatura que se verá completo
 * @param {dataLength} dataLength longitud de los datos del eje X
 * @returns number que indica donde comenzará el datazoom
 */
export function calculateXAxisStart(dataLength) {
  return (100 * (dataLength - 120)) / dataLength;
}

/**
 * TODO: devuelve a lista de elementos del eje X en el formato adecuado
 * @param {dataLength} dates datos del eje X
 * @returns array con los elementos del eje X en formato correcto
 */
export function xAxisFormatWithoutYear(dates) {
  const array = Array.from(dates.values());
  return array.map((date) => {
    const [day, month] = date.split('/');
    return formatDDMM(date);
  });
}

export function echartLine(
  datos,
  isXfilter,
  nameMarginY,
  nombreChart,
  nombreLabel,
  idChart,
  idNoData,
  idTable,
  isHistoric = false,
  xAxisFormatter = false,
  datazoomStart = undefined,
  isLegend = true,
  color = COLORS.slice(),
  isDecimal = false,
  legendSpace = undefined,
  minData = undefined,
) {
  const misDatosArray = datos.resultset || datos;
  if (misDatosArray.length === 0) {
    printNoDataChart(`#${idChart}`, `#${idNoData}`);
    if (idTable) printNoDataChart(`#${idTable}`, `#${idNoData}`);
  } else {
    printDataChart(`#${idNoData}`, `#${idChart}`);
    if (idTable) printDataChart(`#${idNoData}`, `#${idTable}`);

    // Obtengo mis datos desde el array

    const cleanData = configureDataLine(misDatosArray, color, isDecimal);

    const serieAccesos = cleanData[0];
    const date = cleanData[1];
    const tiposArray = cleanData[2];
    const legend = isLegend ? tiposArray : null;
    const xAxisFormat = xAxisFormatter
      ? xAxisFormatWithoutYear(date)
      : Array.from(date.values());

    if (datazoomStart === undefined) {
      datazoomStart = isHistoric
        ? calculateXAxisMonth(date.size)
        : calculateXAxisStart(date.size);
    }

    const option = getCommonOptions(
      serieAccesos,
      legend,
      xAxisFormat,
      nombreLabel,
      datazoomStart,
      isXfilter,
      nameMarginY,
      undefined,
      nombreChart,
      undefined,
      undefined,
      undefined,
      legendSpace,
      minData,
    );
    initChart(idChart, option);
  }
}

/**
 * Se proporciona una fecha en formato string y la devuelve en formato Date.
 * @param {String} date Fecha en formato String dd/mm/yyyy
 * @returns {Date} Fecha transformada a Date
 */
export function getDateFromStr(date) {
  // Obtener los valores de día, mes y año
  const fechaParts = date.split('/');
  const dia = parseInt(fechaParts[0], 10);
  const mes = parseInt(fechaParts[1], 10) - 1; // Restar 1 al mes
  const anio = parseInt(fechaParts[2], 10);
  const result = new Date(anio, mes, dia);
  return result;
}

/**
 * Se proporciona una fecha en formato Date y la devuelve en formato String.
 * @param {Date} date Fecha del tipo Date
 * @returns {String} Fecha de tipo string en formato dd/mm/yyyy
 */
export function getStringFromDate(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());

  return `${day}/${month}/${year}`;
}

/**
 * Se proporciona un rango de fechas y devuelve un array que contiene todos los dias existentes
 * en ese rango.
 * @param {Date} fechaInicio Fecha de Inicio del rango en formato Date.
 * @param {Date} fechaFin Fecha final del rango en formato Date.
 * @returns {Array} Array de fechas en formato string dd/mm/yyyy.
 */
export function generateDatesArray(fechaInicio, fechaFin) {
  const fechasArray = [];
  while (fechaInicio <= fechaFin) {
    const fechaActual = getStringFromDate(fechaInicio);
    fechasArray.push(fechaActual);
    fechaInicio.setDate(fechaInicio.getDate() + 1);
  }
  return fechasArray;
}

/**
 * Se proporciona un map con clave de fechas y valor de datos.
 * Este devuelve devuelve un Array con dos Arrays dentro.
 * El primero contiene las fechas con los dias que faltan y
 * el segundo contiene los valores poniendo un null en los huecos de las fechas que no tienen datos.
 * @param {Map} mapDataStr Map con claves de Fechas de tipo string dd/mm/yyyy
 * y con valores de los datos a mostrar en la grafica.
 * @returns Array con dos elementos: Array de Fechas de tipo string dd/mm/yyyy y Array de Datos.
 */
export function addDatesToGaps(mapDataStr) {
  const arrayDates = Array.from(mapDataStr.keys(), (date) =>
    getDateFromStr(date),
  );
  const result = [];
  const arrayData = [];
  const dateMin = new Date(Math.min(...arrayDates));
  const dateMax = new Date(Math.max(...arrayDates));

  const arrayDatesFull = generateDatesArray(dateMin, dateMax);

  arrayDatesFull.forEach((date) => {
    if (mapDataStr.has(date)) {
      const valor = mapDataStr.get(date);
      arrayData.push(valor);
    } else {
      arrayData.push(null);
    }
  });
  result.push(arrayDatesFull);
  result.push(arrayData);
  return result;
}

export function indoPopUp() {
  $('#idPopupInfo').show();
}

export function closePopUp() {
  $('#idPopupInfo').hide();
}

export function filterWindow() {
  $('#layoutFilter').css('display') === 'none'
    ? $('#layoutFilter').show()
    : $('#layoutFilter').hide();
}
